export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/point.js
// module id = 55
// module chunks = 0